var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.bool)?_c('v-icon',{attrs:{"color":"successAccent"}},[_vm._v(" mdi-check ")]):_c('v-icon',{attrs:{"color":"errorAccent"}},[_vm._v(" mdi-close ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }